(function () {

  'use strict';

  angular.module('eclipseApp.checkout').controller('riskClassModalCtrl', ['$scope', '$modalInstance', 'data', 'buyService', '$translate', '$window', 'env', function ($scope, $modalInstance, data, buyService, $translate, $window, env) {

    $scope.riskClassContent = {};

    $scope.riskClassData = data;
    
    $scope.requestIndepthEval = data.requestIndepthEvalMethod;

    $scope.getPermission = buyService.getPermission;

    buyService.getRiskClassViewContent(data.riskClassCode).then(function(resp){
      $scope.riskClassContent.text = resp;
    }, function(resp){
      $scope.riskClassContent.text = resp;
    });

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $window.location.replace(env.fidoHomePageUrl);
    };


  }]);

})();
